import viewLoans from "./viewLoans"
export default viewLoans;
